import { render, staticRenderFns } from "./Pitanje.vue?vue&type=template&id=61d67c51&"
import script from "./Pitanje.vue?vue&type=script&lang=js&"
export * from "./Pitanje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports